import Vue from 'vue'
import Router from 'vue-router'

//common scripts
import user from './user'
import {initConfig} from './manifest'

//common views
import Modules from '../views/modules'
import NotFound from '../views/not-found'
import LoginError from '../views/login-error'

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)

//创建路由对象
let router = new Router({
  mode: 'history', // base: process.env.BASE_URL,
  routes: [
    {name: 'error', path: '/error', component: LoginError, meta: {loginNotRequired: true}} //component: () => import('../views/About.vue')
  ]
})

//
let initRoutes = () => {
  let {commonRoutes, consoleRoutes} = initConfig()
  router.addRoute({path: '/', component: Modules, children: consoleRoutes})
  commonRoutes.concat({name: '404', path: '*', component: NotFound}).forEach(route => router.addRoute(route))
}
if (user.isValidLogin()) initRoutes()

//路由跳转拦截
router.beforeEach((to, from, next) => {

    let {loginNotRequired, permission, role} = to.meta

    //不需要登录的页面 -> 正常访问
    if (loginNotRequired) next()

      //刚登录 -> 更新用户信息
      // else if (to.path === '/ssologin') user.updateInfo(to.query.tokenId, (success, path = '/') => {
      //   //更新成功 -> 跳转页面
      //   if (success) {
      //     initRoutes()
      //     next({path, replace: true})
      //   } else next({path: '/error'})
      // })

    //未登录 -> 跳转登录
    else if (!user.isValidLogin()) user.toLogin(to.fullPath)

    //访问的是显示无权限页面时
    else if (to.path.includes('/not-accessible')) {
      if (user.permissionCheck(permission, role)) next({path: to.path.replace('/not-accessible', ''), replace: true})
      else next()
    }

    //已登录 && 有权限 -> 正常访问
    else if (user.permissionCheck(permission, role)) {
      next()
      user.sendVisitRecord(to)
    }

    //已登录 && 无权限 -> 无权限页
    else next({path: to.path + '/not-accessible', replace: true})
  }
)

export default router